import { format } from 'date-fns';
import type { DesignationChangeSummary } from '../../../types/admin-advisor.type';

/**
 * Human-readable formatting for the most recent designation change (Feature 071).
 * Renders a "Set to …" variant on a first-set (null prior value) and a
 * champion-specific phrasing for the boolean flag. Uses a fixed date format
 * (matching AdvisorTable) so the line renders deterministically across locales.
 */
export const formatDesignationChange = (change: DesignationChangeSummary): string => {
  const when = format(new Date(change.changedAt), 'MMM d, yyyy');
  const by = `by ${change.changedByEmail} on ${when}`;

  if (change.field === 'isFirmChampion') {
    return change.toValue
      ? `Marked as Firm Champion ${by}`
      : `Removed Firm Champion ${by}`;
  }

  const to = String(change.toValue ?? '');
  if (change.fromValue === null || change.fromValue === undefined || change.fromValue === '') {
    return `Set to ${to} ${by}`;
  }
  return `Changed from ${String(change.fromValue)} to ${to} ${by}`;
};
